// Canonical site URL — used in canonical/OG/JSON-LD across routes.
// Keep this in sync with the deployed domain.
export const SITE_URL = "https://notaq.lovable.app";
export const OG_IMAGE = `${SITE_URL}/og-image.jpg`;
